export default "__VITE_ASSET__BtBtlLIB__"